import { useCallback, useEffect, useMemo, useState } from "react";
import _ from 'lodash'

import Button from "components/shared/button";
import { LinkButton } from "components/LinkButton";
import Input, { InputType } from "components/shared/inputs/input";
import { Popup } from "components/popups/Popup";
import useCustomForm from "utils/hooks/useCustomForm";
import { useSalesNetwork } from "utils/hooks/useSalesNetworks";

import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { addNotification } from "store/componentsSlice";
import { useAppDispatch, useAppSelector } from "store/hooks";
import useTranslation from "utils/hooks/useTranslation";
import CustomSelector from "pages/project/CustomSelector";
import { SvgCommandAdd, SvgCommandReport, SvgCommandSearch, SvgSuccessInvert } from "components/svg";
import { useGetClientsQuery, useLazyGetParamentersQuery } from "store/api";
import { ClientPopup } from "./ClientPopup";
import { usePopup } from "providers/PopupProvider";
import { useProject } from "utils/hooks/useProject";
import type { ProjectInfoDataHeader } from "types/Project";


const CLIENTS_ITEMS = [
    {
        value: "1",
        code: 1,
        label: 'CLIENT_SEARCH',
        icon: <SvgCommandSearch />
    },
    {
        value: "2",
        code: 2,
        label: 'NEW_CUSTOMER',
        icon: <SvgCommandAdd />
    },
];

const defaultForm: any = {
    projectName: '',
    projectRef: '',
    technician: '',
    registerClient: false,
    synthesisTitle: true,
    client: {
        data: {
            companyName: '',
            address: '',
            cp: '',
            city: '',
            name: '',
            phone: '',
        }
    }
};

export const SaveProjectPopup: React.FC<{
    closePopup: any;
    onClose?: () => void;
    showGenerateButton?: boolean;
    handleSaveModalResponse?: any;
    toggle?: () => void;
}> = ({
    //closePopup, 
    onClose, showGenerateButton, handleSaveModalResponse
    //, toggle
}) => {
        const { openPopup, closeLastPopup } = usePopup();
        const dispatch = useAppDispatch();
        const { t } = useTranslation();
        const { network } = useSalesNetwork()
        const ProjectService = useProject();
        const projectStore = useAppSelector((state) => state.project)
        const [selectedClient, setSelectedClient] = useState<any>(projectStore.project?.header?.client);
        const [data, setData] = useState({
            showClients: false,
            clients: null,
            filteredClients: null,
            searchInput: '',
            showAlert: false,
            clientToDelete: null,
            showSynthesisTitle: null
        });
        const [clientTab, setClientTab] = useState<number>(0);
        const { data: ClientsData, isFetching, isSuccess } = useGetClientsQuery({
            pageNumber: 1,
            pageSize: 100,
            searchInput: ""
        });
        const [getParameters] = useLazyGetParamentersQuery();
        const currentUserId = useAppSelector((state) => state.auth.profile.id);

        const schema: yup.ObjectSchema<ProjectInfoDataHeader> | any = yup.object({
            technician: yup.string().required(),
            projectName: yup.string().required(),
            projectRef: yup.string().required(),
            clientTab: yup.number().required(),
            client: clientTab === 2 ? yup.object().shape({
                data: yup.object().shape({
                    //companyName: yup.string().required(),
                    companyName: yup.string().notRequired(),
                    address: yup.string().required(),
                    cp: yup.string().required(),
                    city: yup.string().required(),
                    name: yup.string().required(),
                    phone: yup.string().required(),
                }),
            }) : yup.object().shape({
                client_id: yup.number().required(),
            }),
        });

        const {
            handleSubmit,
            formState: { errors },
            //reset,
            control,
            setValue,
            getValues
        } = useCustomForm<any>(
            {
                defaultValues: useMemo(
                    () => ({
                        ...defaultForm, ...projectStore.project.header,
                        //client: selectedClient
                    }),
                    [projectStore.project.header]),
                resolver: yupResolver(schema),
            }
        );

        const onClientTabChange = useCallback(
            (code?: number) => {
                setClientTab(code as any)
                setValue("clientTab", code as number, { shouldDirty: true, shouldValidate: true })
            },
            [setClientTab, setValue],
        )

        const onEditClient = useCallback(() => {
            openPopup(
                <ClientPopup
                    client={selectedClient}
                    closePopup={closeLastPopup}
                ></ClientPopup>)

        }, [selectedClient, openPopup, closeLastPopup])

        const convertToSelectClient = <T extends { id: number; data: any }>(
            list?: T[]
        ): (Omit<T, 'code' | 'label'> & { value: string; text: string })[] => {
            // @ts-ignore
            return list?.map(({ id, data, ...rest }) => ({
                ...rest,
                value: id,
                text: data.companyName ? `${data.companyName} - ${data.name}` : data.name,
            })) ?? [];
        };

        useEffect(() => {
            setData((prevData) => ({
                ...prevData,
                clients: convertToSelectClient(ClientsData?.clients as any[]) as any
            }))
            // debugger
            if (selectedClient) {
                const _selectedClient = ClientsData?.clients?.filter(i => i.id === selectedClient?.id)[0];
                setSelectedClient(_selectedClient);

                setValue("client", _selectedClient);
                setValue("client.client_id", _selectedClient?.id);
                setValue("clientTab", 1, { shouldDirty: true, shouldValidate: true })
            } else if (projectStore.project.header?.client.id) {
                if (projectStore.project.header?.client.user_id === currentUserId) {
                    const _selectedClient = ClientsData?.clients?.filter(i => i.id === projectStore.project.header.client.id)[0];
                    setSelectedClient(_selectedClient);

                    setValue("client", _selectedClient);
                    setValue("client.client_id", _selectedClient?.id);
                    if (clientTab === 0) {
                        setClientTab(1);
                        setValue("clientTab", 1, { shouldDirty: true, shouldValidate: true })
                    }
                } else {

                    setValue("client", defaultForm.client);
                    setClientTab(2);
                    setValue("clientTab", 2, { shouldDirty: true, shouldValidate: true })
                }
            } else if (projectStore.project.header?.client.data.companyName) {
                if (clientTab === 0) {
                    setClientTab(2);
                    setValue("clientTab", 2, { shouldDirty: true, shouldValidate: true })
                } 0
            }
        }, [isSuccess, ClientsData])

        useEffect(() => {
            async function fetchData() {
                const settings = await getParameters({ env: network?.id }).unwrap();

                let Modulation_note_dim = settings.filter((i: any) => i.code === 'Modulation_note_dim')[0];

                if (Modulation_note_dim) {
                    Modulation_note_dim = settings.filter((i: any) => i.code == 'Modulation_note_dim')[0].value;
                }

                setData((prevData) => ({
                    ...prevData,
                    showSynthesisTitle: Modulation_note_dim as any
                }));

                // if (modalIsOpen) {
                //     if (ProjectStore.project.id && ProjectStore.project.header) {
                //         formStore.form = { ...ProjectStore.project.header }
                //     }
                // }
            }

            fetchData();
        }, [])

        const onGenerate = useCallback(() => {
            handleSaveModalResponse?.({ header: getValues() }) // NOSONAR
            //toggle && toggle(); // NOSONAR
        }, [handleSaveModalResponse, getValues])

        const onSubmit = useCallback(async (formData: any, shareStudy = false) => {
            let breackChainError = false;
            try {
                const _formData = {
                    ...projectStore.project.header,
                    technician: formData.technician,
                    projectName: formData.projectName,
                    projectRef: formData.projectRef,
                    registerClient: formData.registerClient ?? projectStore.project.header?.registerClient,
                    synthesisTitle: formData.synthesisTitle ?? projectStore.project.header?.synthesisTitle,
                    client: {
                        data: {
                            companyName: formData.client.data.companyName ?? projectStore.project.header?.client?.data?.companyName,
                            address: formData.client.data.address ?? projectStore.project.header?.client?.data?.address,
                            city: formData.client.data.city ?? projectStore.project.header?.client?.data?.city,
                            cp: formData.client.data.cp ?? projectStore.project.header?.client?.data?.cp,
                            name: formData.client.data.name ?? projectStore.project.header?.client?.data?.name,
                            phone: formData.client.data.phone ?? projectStore.project.header?.client?.data?.phone,
                        },
                        id: formData.client.id ?? projectStore.project.header?.client?.id,
                        user_id: projectStore.project.header?.client?.user_id,
                        createdBy: projectStore.project.header?.client?.createdBy,
                        updatedBy: projectStore.project.header?.client?.updatedBy,
                        createdAt: projectStore.project.header?.client?.createdAt,
                        updatedAt: projectStore.project.header?.client?.updatedAt,
                    }
                };
                //_formData = _.merge(_formData, formData);
                await ProjectService.save(_formData)
                    .then((result: any) => {
                        if (!result) throw new Error("Project save failed");
                        const savedProject = result?.id != null ? result : result?.data;
                        const projectId = savedProject?.id ?? projectStore.project.id;
                        const uid = savedProject?.data?.uid ?? projectStore.project.uid;
                        if (shareStudy && (projectId == null || !uid)) {
                            throw new Error("Saved project sharing details are missing");
                        }
                        setTimeout(() => {
                            dispatch(addNotification({
                                type: 'success',
                                message: t("PROJECT_SAVED"),
                            }))
                        }, 500)

                        ProjectService.updateProjectId(projectId)
                        // // //toggle && toggle(); // NOSONAR

                        ProjectService.setHeader(_formData)
                        ProjectService.saveStore()

                        // if (handleSaveModalResponse) handleSaveModalResponse({ header: getValues() }) // NOSONAR
                        if (!shareStudy) {
                            handleSaveModalResponse?.({ header: _formData }) // NOSONAR
                        }

                        onClose?.();

                        if (shareStudy) {
                            const subject = encodeURIComponent(t("SHARE_PROJECT_SUBJECT"));
                            const body = encodeURIComponent(t("SHARE_PROJECT_BODY") + "\n\n" +
                                `${window.location.origin}/${network?.code}/load_project/${projectId}/${uid}`);
                            const recipient = network?._parameters?.mail ?? "";
                            window.location.href = `mailto:${recipient}?subject=${subject}&body=${body}`;
                        }

                        return Promise.resolve()

                    })
            } catch (err: any) {
                if (!breackChainError) {
                    dispatch(addNotification({
                        type: "error",
                        message: t('SOME_FIELDS_NEED_YOUR_ATTENTION')
                    }))
                    breackChainError = true
                }
                return Promise.reject(err)
            }
        }, [projectStore.project, ProjectService, dispatch, t, handleSaveModalResponse, onClose, network])

        //console.log(getValues())
        //console.log(projectStore.project.header);

        const onChangeNumberOnly = useCallback((e: any) => {
            e.target.value = e.target.value.replace(/[^0-9]/g, '') // NOSONAR
            setValue(e.target.name, e.target.value);
        }, [setValue])

        const onChangeTextOnly = useCallback((e: any) => {
            e.target.value = e.target.value.replace(/[^A-zÀ-ú0-9 +-_']/gi, '') // NOSONAR
            setValue(e.target.name, e.target.value);
        }, [setValue])

        const toolbarContext = (
            <>
                {data.showSynthesisTitle === true && <group data-gap="20">

                    <group data-length="forcefit" data-fit="1">
                        <Input
                            dataLength="autofit"
                            label={t("SYNTHESIS_TITLE")}
                            control={control}
                            name="synthesisTitle"
                            type={InputType.Checkbox}
                            size="large"
                            checkboxProps={{ "data-text-size": "medium" }}
                            error={errors.synthesisTitle?.message}
                        />
                    </group>
                </group>}
                <group data-gap="20">
                    <group data-length="forcefit" data-fit="1">
                        <group data-justify="start" data-gap="20" data-fit="1">
                            <Button
                                data-length="forcefit"
                                secondary
                                large
                                onClick={handleSubmit((formData) => onSubmit(formData))}
                            >
                                {showGenerateButton ? t("NAV_SAVE_AND_GENERATE") : t("NAV_SAVE")}
                            </Button>
                            {showGenerateButton && <Button
                                data-length="forcefit"
                                secondary
                                large
                                onClick={onGenerate}
                            >
                                {t("GENERATE")}
                            </Button>}
                            <Button
                                data-length="forcefit"
                                accent
                                secondary
                                large
                                onClick={onClose}
                            >
                                {t("CANCEL")}
                            </Button>
                            <LinkButton
                                icon={<SvgCommandReport />}
                                gap={15}
                                title={t("SHARE_STUDY")}
                                onClick={handleSubmit((formData) => onSubmit(formData, true))}
                            />

                        </group>
                    </group>
                </group>
            </>);

        return (
            <Popup
                title={t("SAVE_MY_PROJECT")}
                translateTitle
                fixSize="medium"
                onClose={onClose}

            >
                <group
                    data-direction="column"
                    data-gap="40"
                    data-space="40"
                    data-space-horizontal="40"
                    data-space-top="5"
                    data-height="autofit"
                >
                    <group data-gap="10">
                        <text data-weight="400" data-text-size="14" data-ellipsis="" data-color="grey-color-dark"><i data-space-horizontal="5" data-color="red">*</i> {t("REQUIRED_FIELDS")}</text>
                    </group>


                    <group data-gap="20">
                        <group data-gap="10">
                            <text data-weight="600" data-text-size="large" data-color="grey-color-dark">{t("PROJECT_INFOS")}</text>
                        </group>
                        <group data-gap="20">
                            <group data-length="forcefit" data-fit="1">
                                <Input
                                    dataLength="autofit"
                                    label={"TECHNICIAN"}
                                    control={control}
                                    name="technician"
                                    type="text"
                                    size="large"
                                    error={errors.technician}
                                    onChange={onChangeTextOnly}
                                    maxLength={25}
                                />
                            </group>
                            <group data-length="forcefit" data-fit="1">
                                <Input
                                    dataLength="autofit"
                                    label={"PROJECT_NAME"}
                                    control={control}
                                    name="projectName"
                                    type="text"
                                    size="large"
                                    error={errors.projectName}
                                    onChange={onChangeNumberOnly}
                                    maxLength={20}
                                />
                            </group>
                        </group>

                        <group data-gap="20">
                            <group data-length="forcefit" data-fit="1">
                                <Input
                                    dataLength="autofit"
                                    label={"PROJECT_REF"}
                                    control={control}
                                    name="projectRef"
                                    type="text"
                                    size="large"
                                    error={errors.projectRef}
                                    maxLength={20}
                                />
                            </group>

                        </group>


                    </group>

                    <group data-gap="20">
                        <group data-gap="10">
                            <text data-weight="600" data-text-size="large" data-color="grey-color-dark">{t("CLIENT_INFOS")}<i data-space-horizontal="5" data-color="red">*</i></text>
                        </group>
                        <group data-gap="20" data-name="custom_option" data-text-size="medium">
                            <CustomSelector name="clientTab" control={control} items={CLIENTS_ITEMS} svgSize="24" itemLength="300" selected={clientTab} onChange={onClientTabChange} />
                        </group>
                        {
                            clientTab === 1 && <>
                                <group data-gap="10" data-space-vertical="20">
                                    <group data-direction="column" data-gap="20">
                                        <group data-gap="20">

                                            <group data-length="forcefit" data-fit="1">
                                                <Input
                                                    dataLength="autofit"
                                                    label={"CLIENT_SEARCH"}
                                                    requiredLabel={true}
                                                    control={control}
                                                    name="client.client_id"
                                                    type={InputType.Select}
                                                    options={data.clients}
                                                    size="large"
                                                    onChange={(e) => {
                                                        const client = ClientsData?.clients?.filter((i) => i.id === e as any)[0];
                                                        setValue("client", client);
                                                        setValue("client.client_id", client?.id);
                                                        setSelectedClient(client as any)
                                                    }}
                                                    value={selectedClient?.id}
                                                    loading={isFetching}
                                                    disabled={!data.clients}
                                                    allowSearch={true}
                                                    error={errors.companyName?.message}
                                                />
                                            </group>

                                        </group>

                                        {selectedClient && <>
                                            <group data-gap="20" data-space-vertical="20" data-space-bottom="">
                                                <group data-length="forcefit" data-fit="1">
                                                    <group data-gap="15" data-align="start">
                                                        <icon data-svg-size="24" data-svg-color="main" data-overflow=""><SvgSuccessInvert /></icon>
                                                        <text data-text-size="17">
                                                            <group data-length="forcefit" data-fit="1">
                                                                <text data-weight="600">
                                                                    {selectedClient.data.companyName}
                                                                </text>
                                                            </group>
                                                            <group data-length="forcefit" data-fit="1">
                                                                <text data-weight="600">
                                                                    {selectedClient.data.name}
                                                                </text>
                                                            </group>
                                                            <space data-height="10"></space>
                                                            <group data-length="forcefit" data-fit="1">
                                                                <text>
                                                                    {selectedClient.data.address}
                                                                </text>
                                                            </group>
                                                            <group data-length="forcefit" data-fit="1">
                                                                <text>
                                                                    {selectedClient.data.cp} {selectedClient.data.city}
                                                                </text>
                                                            </group>
                                                            <space data-height="10"></space>
                                                            <group data-length="forcefit" data-fit="1">
                                                                <text>
                                                                    {selectedClient.data.phone}
                                                                </text>
                                                            </group>

                                                        </text>
                                                    </group>

                                                </group>
                                                <group data-length="forcefit" data-fit="1">
                                                    <group data-justify="end">
                                                        <Button
                                                            data-length="forcefit"
                                                            accent
                                                            secondary
                                                            large
                                                            onClick={onEditClient}
                                                            icon="edit"
                                                        >
                                                            {t("UPDATE")}
                                                        </Button>
                                                    </group>
                                                </group>


                                            </group>
                                            {/* <separator data-horizontal=""></separator>

                                            {toolbarContext} */}
                                        </>}
                                    </group>

                                </group>
                            </>
                        }
                        {
                            clientTab === 2 && <>
                                <group data-gap="10" data-space-vertical="20">
                                    <group data-direction="column" data-gap="20">
                                        <group data-gap="20">
                                            <group>
                                                <group data-gap="10">
                                                    <text data-weight="400" data-text-size="medium" data-ellipsis="" data-color="grey-color-dark">
                                                        {t("CUSTOMER_IDENTITY")}<i data-space-horizontal="5" data-color="red">*</i>
                                                    </text>
                                                </group>
                                                <group data-gap="10">
                                                    <text data-weight="400" data-text-size="14" data-ellipsis="" data-color="grey-color-dark">
                                                        {t("CUSTOMER_IDENTITY_WARNING")}
                                                    </text>
                                                </group>
                                            </group>


                                            <group data-length="forcefit" data-fit="1">
                                                <Input
                                                    dataLength="autofit"
                                                    label={"CLIENT_COMPAGNY_NAME"}
                                                    //requiredLabel={true}
                                                    control={control}
                                                    name="client.data.companyName"
                                                    type="text"
                                                    size="large"
                                                    error={errors.companyName?.message}
                                                    onChange={onChangeTextOnly}
                                                    maxLength={25}
                                                />
                                            </group>
                                            <group data-length="forcefit" data-fit="1">
                                                <Input
                                                    dataLength="autofit"
                                                    label={"CLIENT_NAME"}
                                                    requiredLabel={true}
                                                    control={control}
                                                    name="client.data.name"
                                                    type="text"
                                                    size="large"
                                                    error={errors.name?.message}
                                                />
                                            </group>
                                        </group>

                                        <group data-gap="20">
                                            <group data-length="forcefit" data-fit="1">
                                                <Input
                                                    dataLength="autofit"
                                                    label={"CLIENT_ADDRESS"}
                                                    requiredLabel={true}
                                                    control={control}
                                                    name="client.data.address"
                                                    type="text"
                                                    size="large"
                                                    error={errors.address?.message}
                                                    onChange={onChangeTextOnly}
                                                    maxLength={50}
                                                />
                                            </group>
                                        </group>

                                        <group data-gap="20">
                                            <group data-length="forcefit" data-fit="1">
                                                <Input
                                                    dataLength="autofit"
                                                    label={"CLIENT_CP"}
                                                    requiredLabel={true}
                                                    control={control}
                                                    name="client.data.cp"
                                                    type="text"
                                                    size="large"
                                                    error={errors.cp?.message}
                                                    onChange={onChangeNumberOnly}
                                                    maxLength={10}
                                                />
                                            </group>
                                            <group data-length="forcefit" data-fit="1">
                                                <Input
                                                    dataLength="autofit"
                                                    label={"CLIENT_CITY"}
                                                    requiredLabel={true}
                                                    control={control}
                                                    name="client.data.city"
                                                    type="text"
                                                    size="large"
                                                    error={errors.city?.message}
                                                    onChange={onChangeTextOnly}
                                                    maxLength={25}
                                                />
                                            </group>
                                        </group>
                                        <group data-gap="20">
                                            <group data-length="forcefit" data-fit="1">
                                                <Input
                                                    dataLength="autofit"
                                                    label={"CLIENT_PHONE"}
                                                    requiredLabel={true}
                                                    control={control}
                                                    name="client.data.phone"
                                                    type="text"
                                                    size="large"
                                                    error={errors.phone?.message}
                                                    onChange={onChangeNumberOnly}
                                                    maxLength={15}
                                                />
                                            </group>
                                        </group>

                                        <group data-gap="0">
                                            <group data-length="forcefit" data-fit="1">
                                                <Input
                                                    dataLength="autofit"
                                                    label={t("REGISTER_CLIENT")}
                                                    control={control}
                                                    name="registerClient"
                                                    type={InputType.Checkbox}
                                                    size="large"
                                                    checkboxProps={{ "data-text-size": "medium" }}
                                                    error={errors.registerClient?.message}
                                                />
                                            </group>
                                            {/* <separator data-horizontal=""></separator> */}
                                        </group>

                                        {/* {toolbarContext} */}

                                    </group>
                                </group>
                            </>
                        }
                        <separator data-horizontal=""></separator>
                        {toolbarContext}
                    </group>
                </group>
            </Popup>
        );
    };